import moment from 'moment';
import { LeftTopArrowCircle } from 'styled-icons/boxicons-solid';
import holidays, { HOLIDAY_DATE_FORMAT } from './holiday';

const SAFE_DATE = '06-06';

// const TIMEZON_OFFSET = new Date().getTimezoneOffset() / 60;

export function fromIgnoredUtc(utcDate) {
  const dateStr = moment(utcDate).format('YYYY-MM-DD');
  return moment(dateStr);
}

export function checkHoliday(momentDate) {
  const holidayKey = momentDate.format(HOLIDAY_DATE_FORMAT);
  return holidays[holidayKey];
}

export function getBusinessDates(month, year = 2019) {
  const momentDate = moment();
  if (month) {
    momentDate
      .year(year)
      .month(month - 1)
      .date(15);
  }

  const startWeek = momentDate.startOf('month').week();
  let endWeek = momentDate.endOf('month').week();

  const weekInfos = [];
  const targetWeek = endWeek < startWeek ? 52 : endWeek;
  for (let week = startWeek; week <= targetWeek; week++) {
    weekInfos.push({
      week,
      year
    });
  }

  if (endWeek < startWeek) {
    for (let week = 1; week <= endWeek; week += 1) {
      weekInfos.push({
        week: 52 + week,
        year: year
      });
    }
  }

  const rows = weekInfos.map(infoItem => {
    const { week: infoWeek, year: infoYear } = infoItem;
    const weekStartDate = moment(`${infoYear}-${SAFE_DATE}`, 'YYYY-MM-DD')
      .week(infoWeek)
      .startOf('week');

    return {
      week: infoWeek,
      year: infoYear,
      days: Array(6)
        .fill(0)
        .map((n, i) => {
          return weekStartDate.clone().add(n + i + 1, 'day');
        })
    };
  });

  return rows;
}

export function isToday(momentDate) {
  return momentDate.isSame(moment(), 'd');
}

export function getMonthName(month) {
  if (month) {
    return moment.months(month - 1);
  }

  return moment().format('MMMM');
}

export function getCurrentMonth() {
  return moment().month() + 1;
}

export function getCurrentYear() {
  return moment().year();
}

export function getWeekRange(startDate, numOfWeeks, items) {
  if (!startDate) {
    return null;
  }

  let momentDate = startDate;
  if (!(startDate instanceof moment)) {
    momentDate = moment(startDate);
  }

  const currentWeek = moment().week();
  const currentDay = moment().day();
  let startWeek = momentDate.week();

  let year = momentDate.year();
  const month = momentDate.month();

  if (startWeek === 1 && month === 11) {
    year += 1;
  }

  if (startWeek === currentWeek && items) {
    const prevDate = items.find(item => {
      return +item.row === 0 && +item.col + 1 <= currentDay;
    });

    if (prevDate) {
      startWeek += 1;
    }
  }
  const end = startWeek + numOfWeeks - 1;

  const weeks = [];

  for (let i = startWeek; i <= end; i += 1) {
    let weekNum = i % 52;
    if (weekNum === 0) {
      weekNum = 52;
    }

    weeks.push(weekNum);
  }

  return {
    start: startWeek,
    end: startWeek + numOfWeeks - 1,
    weeks,
    year
  };
}

export function getStartDateOfWeek(infoWeek, infoYear) {
  const weekStartDate = moment(`${infoYear}-${SAFE_DATE}`, 'YYYY-MM-DD')
    .week(infoWeek)
    .startOf('week');
  return weekStartDate;
}

export function getFirstWeekOfMonth(month) {
  const momentDate = moment();
  const year = momentDate.year();
  if (month > 12) {
    momentDate
      .year(year + 1)
      .month(month - 12 - 1)
      .date(15);
  } else if (month < 1) {
    momentDate
      .year(year - 1)
      .month(12 + month - 1)
      .date(15);
  } else {
    momentDate.month(month - 1).date(15);
  }

  return momentDate.startOf('month').week();
}

export function getToday() {
  return moment().format('ll');
}

export function isWithin24Hours(serviceDate) {
  const diffHours = moment(serviceDate).diff(moment(), 'h');
  return diffHours <= 24;
}

export const checkWeekdayCoupon = (currentClean, selectedDate) => {
  if (currentClean && currentClean.cost && currentClean.cost.couponDetails) {
    const { dayOfWeek: weekdays } = currentClean.cost.couponDetails;
    if (weekdays && weekdays.length > 0) {
      const formattedDay = selectedDate.momentDate.format('dddd').toLowerCase();
      if (!weekdays.includes(formattedDay)) {
        return true;
      }
    }
  }
  return false;
};
